/**
 * Schedules a repeated action.  This is not a true interval since we schedule the next one after the previous action completes.
 * This prevents an issue where slow running actions result in pileups.
 * @param intervalInMs
 * @param action
 */
export const scheduleInterval = <T>(
  intervalInMs: number,
  func: () => Promise<T>,
) => {
  let timeout: NodeJS.Timeout | null = null

  const action = async () => {
    timeout = null
    await func()
    timeout = setTimeout(action, intervalInMs)
  }

  timeout = setTimeout(action, intervalInMs)

  return () => {
    if (timeout !== null) {
      clearTimeout(timeout)
    }
  }
}

export const scheduleTimeout = (intervalInMs: number, action: () => void) => {
  const timeout = setTimeout(action, intervalInMs)

  return () => {
    clearTimeout(timeout)
  }
}
